import { useAppointmentsInfoShallowStore } from './use-appointments-info-store';

export const useGetAppointmentInfo = (eventId: string) => {
  const { appointments } = useAppointmentsInfoShallowStore('appointments');

  const appointmentDetails = appointments?.find((appointment) => appointment.id === eventId);

  return {
    appointmentDetails,
  };
};
